export function applyStructureGallery() {
let gallery = null;

/**
 * load app to show responsive gallery
 * @param {boolean} shouldCreateGallery control if we need to create or destroy the application
 * @return {Promise<void>}
 */
async function loadResponsiveGallery(shouldCreateGallery) {
  if (shouldCreateGallery) {
      gallery = (await import("./main.js")).default;
    await gallery.createStructureGallery();
  }
  else {
    gallery?.removeStructureGallery();
  }
}

  const mobileBreakpoint = window.matchMedia("(max-width: 991.98px)");
  mobileBreakpoint.addEventListener("change", ({ matches }) =>
    loadResponsiveGallery(matches)
  );
void loadResponsiveGallery(mobileBreakpoint.matches);
}
